import { useState, useEffect } from "react";
import NavList from "../Nav/NavList";
import { Link } from "react-router-dom";
import logo from "../../images/logo/hero_logo.png";
import {
  FaXmark,
  FaBars,
  FaPlus,
  FaInstagram,
  FaWhatsapp,
  FaPhone,
} from "react-icons/fa6";

function Navbar() {
  const [spin, setSpin] = useState(false);
  const [sticky, setSticky] = useState(false);
  const [hamburger, setHamburger] = useState(false);

  const joinSpin = () => {
    setSpin(true);
  };

  const stopSpin = () => {
    setSpin(false);
  };

  // sticky navbar - bg black on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const hamburgerMenu = () => {
    setHamburger(!hamburger);
  };

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Pricing & Offers", path: "/pricing" },
    { label: "Trainings", path: "/trainings" },
    { label: "Equipments", path: "/equipments" },
    { label: "Gallery", path: "/gallery" },
    { label: "Testimonials", path: "/testimonials" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300">
        {/* ========================================== */}
        {/* Top Header Section                         */}
        {/* ========================================== */}
        <div className="bg-[#ff0336] text-white text-[11px] sm:text-[12.5px] font-extrabold py-2.5 sm:py-3 px-4 sm:px-8 md:px-12 flex justify-between items-center w-full shadow-md z-50 select-none">
          {/* Phone Number */}
          <div className="flex items-center gap-2">
            <FaPhone className="text-[#ffd600] text-[11px] sm:text-[12px]" />
            <a
              href="tel:+918637488702"
              className="hover:text-[#ffd600] tracking-wide transition-colors duration-200"
            >
              +91 86374 88702
            </a>
          </div>

          {/* Motivational Gym Quote */}
          <div className="hidden md:block uppercase tracking-[3px] text-[#ffd600] font-black animate-pulse">
            ⚡ The Body You Want Starts With The Work You Do.
          </div>

          {/* Socials Quick Links */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/nk_.nandhu"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram Link"
              className="hover:text-[#ffd600] text-[13px] sm:text-[14px] transition-colors duration-200"
            >
              <FaInstagram />
            </a>
            <a
              href="https://wa.me/918637488702"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp Link"
              className="hover:text-[#ffd600] text-[13px] sm:text-[14px] transition-colors duration-200"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* ========================================== */}
        {/* Main Navigation Bar                        */}
        {/* ========================================== */}
        <nav
          className={`flex flex-row items-center justify-between py-4 sm:py-5 px-4 sm:px-6 md:px-8 lg:px-12 transition-all duration-300 ${
            sticky
              ? "shadow-2xl bg-black/95 backdrop-blur-md border-b border-neutral-900"
              : "bg-black/30 backdrop-blur-sm"
          }`}
        >
          {/* Gym Logo */}
          <Link to="/" onClick={goTop} className="flex items-center shrink-0">
            <img
              src={logo}
              className="w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] md:w-[70px] md:h-[70px] object-contain transition-transform duration-300 hover:scale-105"
              alt="FAT2FIT Logo"
            />
          </Link>

          {/* Desktop Nav Links */}
          <div className="navlist-nav hidden lg:block">
            <NavList />
          </div>

          {/* Right Action Section */}
          <div className="flex items-center gap-3 sm:gap-4">
            {/* Book Free Trial Button */}
            <div className="nav-joinbtn border-neutral-800 border-solid border-2 p-1 rounded-md shrink-0">
              <a
                href="https://wa.me/918637488702?text=Hi%2C%20I%20want%20to%20book%20a%20free%20trial%20at%20FAT2FIT!"
                target="_blank"
                rel="noreferrer"
                onMouseEnter={joinSpin}
                onMouseLeave={stopSpin}
                className="flex items-center"
              >
                <FaPlus
                  className={`bg-[#ffd600] text-black text-sm sm:text-base py-1.5 px-2.5 sm:py-2 sm:px-3 rounded-md transition-transform duration-500 ${
                    spin ? "rotate-90 bg-[#ff0336] text-white" : ""
                  }`}
                />
                <h3 className="text-white text-[10.5px] sm:text-[12px] md:text-[13px] font-bold uppercase ml-2 sm:ml-3 mr-2 sm:mr-4 tracking-wider">
                  Book Free Trial
                </h3>
              </a>
            </div>

            {/* Mobile Hamburger Button */}
            <button
              onClick={hamburgerMenu}
              aria-label="Open navigation menu"
              className="lg:hidden text-white text-2xl sm:text-3xl cursor-pointer hover:text-[#ffd600] transition-colors duration-200"
            >
              <FaBars />
            </button>
          </div>

          {/* ========================================== */}
          {/* Fullscreen Mobile Drawer                   */}
          {/* ========================================== */}
          <div
            className={`flex top-0 flex-col fixed w-full left-0 h-screen bg-black/95 backdrop-blur-lg text-white z-[999999] py-8 px-6 sm:px-10 transition-all duration-500 ease-in-out ${
              hamburger ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-8"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={hamburgerMenu}
              aria-label="Close navigation menu"
              className="text-[#ff0336] text-[28px] sm:text-[33px] cursor-pointer self-end p-2 hover:scale-110 transition-transform duration-200"
            >
              <FaXmark />
            </button>

            {/* Mobile Links List */}
            <ul className="text-center flex flex-col gap-6 sm:gap-8 absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] w-full max-w-xs">
              {menuItems.map((item, index) => (
                <li key={index} onClick={hamburgerMenu}>
                  <Link
                    onClick={goTop}
                    className="text-[20px] sm:text-[24px] font-black uppercase tracking-wider hover:text-[#ffd600] transition-colors duration-200 block py-1"
                    to={item.path}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Navbar;
